import(/* webpackMode: "eager" */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/app/ja/reset-password/page.tsx");
